import React, { useEffect, useReducer, useContext } from 'react';
import styled from 'styled-components/macro';
import axios from 'axios';
import { parseQuery } from '../tools';
import OutdoorMap from './components/outdoor-map';
import OutdoorControlPanel from './components/outdoor_control_panel';
import LayersControl from './components/layers_control';
import ContextMenu from './components/context_menu';
import EditModal from './components/edit_modal';
import PolygonsCatalogModal from './components/polygon_modal';

import SpacesContext from './context';
import { GlobalContext } from '../../App';
import SpacesReducer from './reducer';

const ShowPolygonsCatalogModal = styled.div`
  cursor: pointer;
  user-select: none;
  position: absolute;
  width: 100px;
  height: 30px;
  bottom: 30px;
  right: 30px;
  background-color: #ccc;
  overflow: hidden;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  z-index: 1001;
`;

const MapContainer = styled.section`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  height: 100%;

  background-color: #fff;
  box-sizing: border-box;
  transition: height 0.5s ease-in-out;
`;

const InnerContainer = styled.section`
  position: relative;
  width: 100%;
  height: 100%;

  background-color: #fff;
  box-sizing: border-box;
  transition: height 0.5s ease-in-out;
  display: flex;
  .leaflet-container {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    cursor: ${props => (props.isPickCursorCoords ? 'crosshair' : '')};
  }
`;

const OutdoorSpaces = React.memo(() => {
  const initialState = useContext(SpacesContext);
  const { token } = useContext(GlobalContext);
  const [state, dispatch] = useReducer(SpacesReducer, initialState);
  const { isPickCursorCoords } = state;

  useEffect(() => {
    if (!token) return;

    getData(`https://admin.client.getshopster.net/adapp/outdoor_ad_spaces/`, 'getOutdoorSpaces');
    getData(`https://admin.client.getshopster.net/outdoor/outdoor_ipoints/`, 'getIPoints');
    getData(`https://admin.client.getshopster.net/adapp/ad_space_types/`, 'getSpacesTypes');
    getData(`https://admin.getshopster.net/ownership_hierarchy/project_locations/`, 'getProjectLocations');
  }, [token]);

  useEffect(() => {
    if (!token || state.projectLocationsData.length === 0) return;
    const query = parseQuery(window.location.search);
    const { projectLocationsData } = state;
    if (query.pl_id) {
      dispatch({
        type: 'selectPL',
        id: Number(query.pl_id)
      });
      const point = projectLocationsData[Number(query.pl_id)];
      if (point) {
        dispatch({
          type: 'aimOnPoint',
          center: { lat: point.latitude, lng: point.longitude }
        });
      }
    }
  }, [state.projectLocationsData]);

  //--

  const getData = async (url, name) => {
    const headers = {
      'x-token': token
    };
    const response = await axios.get(url, { headers });
    dispatch({
      type: name,
      payload: {
        json: await response.data
      }
    });
  };

  const onClick = e => {
    dispatch({
      type: 'togglePolygonsCatalogModal'
    });
  };

  return (
    <SpacesContext.Provider value={{ state, dispatch }}>
      <MapContainer>
        <OutdoorControlPanel />
        {state.polygonsCatalogModal.show ? <PolygonsCatalogModal /> : null}
        <InnerContainer isPickCursorCoords={isPickCursorCoords}>
          {state.currentZoom === 18 ? <ShowPolygonsCatalogModal onClick={onClick}>Polygons</ShowPolygonsCatalogModal> : null}
          <EditModal />
          <OutdoorMap />
        </InnerContainer>
        {state.contextMenu.show ? <ContextMenu /> : null}
      </MapContainer>
    </SpacesContext.Provider>
  );
});

export default OutdoorSpaces;
